<template>
  <!-- content -->
    <div class="content--block" v-if="pageDetails">
        <div class="custom-content--heading">
            <h3>{{ pageDetails.title }}</h3>
        </div>
        <div class="custom-content--list" style="overflow:hidden"><img class="simple-image" :src="pageDetails.imageUrl" alt=""><span v-html="pageDetails.publishedContent"/>
        </div>
        </div>
</template>
<script>
import * as api from "../modules/api.js";

export default {
  name: "single-news",
  data: function() {
    return {
      permalink: null,
      pageDetails: null
    };
  },
  mounted() {
    this.permalink = this.$route.path.split("/").pop();
    let me = this;
    api.request(api.pageGetByPermalink, {}, me.permalink).then(function(value) {
      me.pageDetails = value;

      if (value.hasOwnProperty("metaTitle") && value.metaTitle) document.title = value.metaTitle;
      if (value.hasOwnProperty("metaDescription") && value.metaDescription) $("meta[name='description']").attr("content", value.metaDescription);

      me.pageDetails.publishedContent = me.pageDetails.publishedContent.replace(
        "<p>&lt;!--more--&gt;</p>",
        ""
      );
    }).catch(function(value) {
      me.$router.push({ path: "/p/pages/404" });
      api.request(api.pageGetByPermalink, {}, '404').then(function(value) {
      me.pageDetails = value;
      me.pageDetails.publishedContent = me.pageDetails.publishedContent.replace(
        "<p>&lt;!--more--&gt;</p>",
        ""
      );
    })
    });
  }
};
</script>